import { render, staticRenderFns } from "./VisitMgList.vue?vue&type=template&id=38c04c66&scoped=true"
import script from "./VisitMgList.vue?vue&type=script&lang=js"
export * from "./VisitMgList.vue?vue&type=script&lang=js"
import style0 from "./VisitMgList.vue?vue&type=style&index=0&id=38c04c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c04c66",
  null
  
)

export default component.exports